<mat-card>
    <mat-card-header>
        <mat-card-title>{{'Brush Settings' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container-fluid">
            <div>
                <mat-checkbox (change)="filterChanged($event)" [checked]="dataExchangeService.painting.marginalFilter"
                              class="check">{{'Filter' | translate}}
                </mat-checkbox>

                <!--                <mat-checkbox>Front and Back</mat-checkbox>-->
            </div>
            <div>
                <mat-checkbox (change)="roentgenChanged($event)" [checked]="dataExchangeService.painting.roentgen"
                              class="check">{{'Front and Back' | translate}}
                </mat-checkbox>

                <!--                <mat-checkbox>Front and Back</mat-checkbox>-->
            </div>
            <div>
                <mat-checkbox (change)="regionsChanged($event)" [checked]="dataExchangeService.painting.regions"
                              class="check" [disabled]="dataExchangeService.painting.regionsLoading"
                              [ngStyle]="{cursor: dataExchangeService.painting.regionsLoading? 'wait': 'default'}"
                              (click)="regionsClick()">{{'Regions' | translate}}
                </mat-checkbox>
                <mat-error *ngIf="regionsClicked && dataExchangeService.painting.regionsLoading">
                    Regions mode is still <br> being initialized.
                    Try again later.
                </mat-error>
                <!--                <mat-checkbox>Regions</mat-checkbox>-->
            </div>
            <div>
                <mat-slider #slider (input)="change($event)" (panend)="inputEnd()"
                            [value]="dataExchangeService.painting.brushSize"
                            max="0.1" min="0.01" step="0.01"></mat-slider>
            </div>

        </div>
    </mat-card-content>


</mat-card>
